export const autoGroupColumnDef = {
  cellRendererParams: {
    checkbox: false,
    suppressCount: true,
  },
};

export const defaultColDef = {
  enablePivot: true,
  enableRowGroup: true,
  enableValue: true,
  filter: true,
  resizable: true,
  sortable: true,
};

export function hlinkFunction(params: any, data: any) {
  if (params.node && params.node.allLeafChildren) {
    return renderLink(params.node.allLeafChildren[0].data.hlink, params.value);
  } else {
    return params.value;
  }
}
function renderLink(href: string, value: string) {
  return `<a href=${href} target="_blank" style="text-decoration: underline; color: black;">${value} </a>`;
}
